import { cn } from "@istari-frontend/shared";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

export const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground placeholder:text-xs selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex w-full min-w-0 rounded-md border bg-transparent text-base shadow-none focus-within:shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      size: {
        default: "h-9 px-3 py-1",
        sm: "h-8 px-2.5 py-1",
        xs: "h-7 px-2 py-0.5 text-sm",
        lg: "h-10 px-4 py-2",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

export const Input = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<"input">, "size"> & VariantProps<typeof inputVariants>
>(({ className, type, size, ...props }, ref) => {
  return (
    <input ref={ref} type={type} data-slot="input" className={cn(inputVariants({ size, className }))} {...props} />
  );
});

Input.displayName = "Input";
